import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { usePmsDepartments, PmsDepartment } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );
  return <GenericListPage<PmsDepartment> useData={usePmsDepartments} config={config} />;
};

export default List;
